import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MemoryDiskUsage } from 'src/app/data-models/widgets/memory-disk-usage.model';
import { StorageUsage } from 'src/app/data-models/widgets/storage-usage.model';
import { DeviceService } from 'src/app/services/device/device.service';
import { SystemUpdateService } from 'src/app/services/system-update/system-update.service';
import { VantageShellService } from 'src/app/services/vantage-shell/vantage-shell.service';

@Component({
	selector: 'vtr-widget-storage-status',
	templateUrl: './widget-storage-status.component.html',
	styleUrls: ['./widget-storage-status.component.scss']
})
export class WidgetStorageStatusComponent implements OnInit {
	@Input() memoryDiskUsage: MemoryDiskUsage;
	constructor(
		private deviceService: DeviceService,
		private vantageShellService: VantageShellService,
	) { }

	ngOnInit(): void {
	}

	public calcLeftAngleDegree(storageUsage: StorageUsage): number {
		if (storageUsage.total === 0) {
			return 0;
		} else {
			let degree = storageUsage.used / storageUsage.total * 360;
			return degree < 180 ? 0 : degree % 180;
		}
	}

	public calcRightAngleDegree(storageUsage: StorageUsage): number {
		if (storageUsage.total === 0) {
			return 0;
		} else {
			let degree = storageUsage.used / storageUsage.total * 360;
			return degree < 180 ? degree : 180;
		}
	}

	public diskDetailClicked(): void {
		this.deviceService.launchUri('ms-settings:storagesense');
	}
	public memoryDetailClicked(): void {
		this.vantageShellService.getSystemUpdate().launchApp('%programdata%\\Microsoft\\Windows\\Start Menu\\Programs\\Administrative Tools\\Resource Monitor.lnk');
	}
}
